import styled from 'styled-components';
import { setTypography, calcPxToRem } from 'utils/styles/mixins';
import { colors, rfs } from 'utils/styles/theme';

export const Footer = styled.footer`
  ${rfs(`${calcPxToRem(60)}rem`, `padding-top`)}
  ${rfs(`${calcPxToRem(110)}rem`, `padding-right`)}
  ${rfs(`${calcPxToRem(30)}rem`, `padding-bottom`)}
  ${rfs(`${calcPxToRem(110)}rem`, `padding-left`)}

  color: ${colors.pattensBlue};
  background-color: ${colors.balticSea};
  border-top: 1px;
  border-style: solid;
  border-color: ${colors.pattensBlue10};
`;
export const Cols = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ${rfs(`${calcPxToRem(115)}rem`, `column-gap`)};
  ${rfs(`${calcPxToRem(50)}rem`, `row-gap`)};
`;

export const Col = styled.div``;

export const ColTitle = styled.div`
  ${rfs(`${calcPxToRem(10)}rem`, `margin-bottom`)}
  ${setTypography('caption')}
  opacity: 40%;
`;

export const ColContent = styled.div`
  ${setTypography('subtitle1')}
`;

export const LayoutHref = styled.div`
  a {
    cursor: url("/svgs/Google_Maps_pin.svg") 10 17, auto;
  }
`;

export const FooterLegal = styled.small`
  ${rfs(`${calcPxToRem(50)}rem`, `margin-top`)}
  ${setTypography('caption')}
  display: flex;
  justify-content: space-between;
  opacity: 50%;
`;
